import { useCallback, useContext, useEffect, useState } from 'react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import PageBuilder from '../../../../library/Builders/PageBuilder/PageBuilder';
import { SmartContext } from '../../../../library/Core/SmartContext';
import smartReducer from '../../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../../library/Core/SmartTypes';
import BasLayout from './BasLayout';
import SessionContext from '../../../../library/Core/SessionContext';
import AssignSession from '../../../student/view/sections/AssignSession';
import { axiosClient } from '../../../../library/Service/axiosClient';
import DebugBarControl from '../../../../library/SimpleControls/DebugBarControl';

const Bas = () => {
    const { sessionState, sessionDispatch } = useContext(SessionContext);
    const [openBookASession,setOpenBookASession] = useState(false);
    const [isMarkedMissed,setisMarkedMissed] = useState(false);
    const [basData,setBasdata] = useState();
    
    
    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {}
    } as any);

    const [url,setUrl] = useState(`${process.env.REACT_APP_CALENDLY_URL}?name=${state?.data?.firstName + ' ' + state?.data?.lastName}&email=${state?.data?.registeredEmailId}&a1=${'Looking forward'}&hide_gdpr_banner=true`);

    const { formConfig, data, internal, routeInfo } = useLoaderData() as State;

    const navigate = useNavigate();
    useEffect(() => {
        if (state?.data?.parents && state.data.parents.length === 0) {
            alert('Thank you for your Interest, Kindly fill your parent details');
            navigate(`/alumni/${routeInfo?.id}/profile/parent-info`);
        }
    }, [state?.data?.parents, routeInfo?.id, navigate]);

    useEffect(() => {
        if (state?.data?.basCloseCase == true) {
            alert('Thank you for your Interest, BAS is closed for this User');
            navigate(`/alumni/${routeInfo?.id}/profile`);
        }
    }, [state?.data, routeInfo?.id, navigate]);

    useEffect(() => {
        dispatch({
            type: 'DATA_INIT',
            payload: { formConfig, data, internal, routeInfo },
        });

        localStorage.setItem('isParentDataFilled','1');
    },[]);

    useEffect(() => {
        if(openBookASession == false || isMarkedMissed == true){
            const getDetails = async () => {
                const response = await axiosClient().post(`${process.env.REACT_APP_BAS_API}/bas/get-bas-last-booking-details`,{userId:routeInfo.id})
                if(response.status == 200)
                {
                    const data = response?.data?.data;
                    setBasdata(data);
                }
            }

            getDetails();
        }
    },[openBookASession,isMarkedMissed])

    

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <BasLayout data={{setUrl , setOpenBookASession , setisMarkedMissed , basData}}>
                <AssignSession data={{ url, openBookASession, setOpenBookASession }} />
            </BasLayout>
            <DebugBarControl></DebugBarControl>
        </SmartContext.Provider>
    );
};

export default Bas;
